

const getPermissoes = ()  => {
    var tk = localStorage.getItem("ebslog.token")
    if ((tk ?? '') != '') {
        return JSON.parse(window.atob(tk.split(".")[1])).role
    }
    return []
}

const internalIsInRole = (permissoes, userPermissoes) => {
    var found = false;
    if (permissoes != null) {
        if (Array.isArray(permissoes)) {
            for (var idx = 0; idx < permissoes.length; idx++) {
                if (userPermissoes.indexOf(permissoes[idx]) != -1) {
                    found = true;
                    break;
                }
            }
        } else {
            found = userPermissoes.indexOf(permissoes) != -1;
        }
    }
    return found
}

const checkAuthorize = (el, permissoes) => {
    let userPermissoes = getPermissoes()
    if (permissoes.value != null) {
        var found = internalIsInRole(permissoes.value, userPermissoes);
        if (!found) {
            el.remove();
        }
    }
}

const addAuthorizeDirective = (app) => {
    app.directive('authorize', {
        mounted(el, permissoes) {
            checkAuthorize(el, permissoes)
        },
        updated(el, permissoes) {
            checkAuthorize(el, permissoes)
        }
    })

    //alguns casos o v-authorize não serve (BTab por exemplo)
    //entao crar uma validacao se usuario tem a role
    app.config.globalProperties.$isInpermissoes = (permissoes) => {
        
        let userPermissoes = getPermissoes()
        if (userPermissoes != null) {
            return internalIsInRole(permissoes, userPermissoes)
        }
        return false
    }
}

export const isInpermissoes = (permissoes) => {
    let userPermissoes = getPermissoes()
    

    if (userPermissoes != null) {
        return internalIsInRole(permissoes, userPermissoes)
    }
    return false
}

export default addAuthorizeDirective
